    // 正規表現
  
    // 半角数字のみ
    // const HankakuSuuzi = (val) => helpers.regex("半角数字", /^[0-9]+$/);
    const HankakuSuuzi =  {
      type: '半角数字',
      valid: /^[0-9]+$/
    };
    // 半角英数字
    const HankakuEisuu =  {
      type: '半角英数字',
      valid: /^[a-zA-Z0-9]+$/
    };
  
    // 全角のみ
    const Zennkaku = {
      type: '全角',
      valid: /^[^ -~｡-ﾟ]+$/
    };
  
    // 全角カナ
    const ZenkakuKana = {
      type: '全角カナ英数',
      valid: /^[０-９ァ-ヶＡ-ｚ\u3000ー－|]*$/
    };
  
    // アドレス
    const MailAddress = {
      type: 'メールアドレス',
      valid: /^[a-zA-Z0-9!$&*.=^`|~#%'+\\/?_{}\-]+@([a-zA-Z0-9_\-]+\.)+[a-zA-Z]{2,6}$/
    };
    // アドレス
    const Mozi9 = {
      type: '9文字',
      valid: /^[!-~]{9}$/
    };
    const Mozi66 = {
      type: '66文字',
      valid: /^[!-~]{66}$/
    };
export default {
  HankakuSuuzi(val){
    return this.checkReg(val, HankakuSuuzi);
  },
  HankakuEisuu(val){
    return this.checkReg(val, HankakuEisuu);
  },
  Zennkaku(val){
    return this.checkReg(val, Zennkaku);
  },
  ZenkakuKana(val){
    return this.checkReg(val, ZenkakuKana);
  },
  MailAddress(val){
    return this.checkReg(val, MailAddress);
  },
  moziSize9(val){
    return this.checkReg(val, Mozi9);
  },
  moziSize9(val){
    return this.checkReg(val, Mozi66);
  },
    /**
     * 入力チェック: 文字列チェック
     * @param {Object} v vuelidateオブジェクト
     * @param {String} name 入力項目名
     * @param {String} regexType 正規表現
     * @returns {Array} エラーメッセージ
     */
    checkStr(v, name, regexType) {
      console.log(regexType);
      // エラーメッセージ
      v.errMsg = [];  
      // 必須入力チェック
      if (!this.emptyCheck(v.required) && !v.required) {
        const msg = `${name}は必須項目です。`;
        v.errMsg.push(msg);
      }
  
      // 最小桁数チェック
      if (!this.emptyCheck(v.minLength) && !v.minLength) {
        const msg = `${name}は${v.$params.minLength.min}文字以上で入力してください。`;
        v.errMsg.push(msg);
      }
  
      // 最大桁数チェック
      if (!this.emptyCheck(v.maxLength) && !v.maxLength) {
        const msg = `${name}は${v.$params.maxLength.max}文字以下で入力してください。`;
        v.errMsg.push(msg);
      }
      // 数値チェック
      if (!this.emptyCheck(v.minValue) && !v.minValue) {
        
        const msg = `${name}は${v.$params.minValue.min}以上で入力してください。`;
        v.errMsg.push(msg);
      }
      if (!this.emptyCheck(v.maxValue) && !v.maxValue) {
        
        const msg = `${name}は${v.$params.maxValue.max}以下で入力してください。`;
        v.errMsg.push(msg);
      }

      if (!this.emptyCheck(v.between) && !v.between) {
        const msg = `${name}は${v.$params.between.min}以上、${v.$params.between.max}以下で入力してください。`;
        v.errMsg.push(msg);
      }
      // if (!this.emptyCheck(v.err) && !v.err) {
      //   const msg = `${name}は${v.$params.between.min}以上、${v.$params.between.max}以下で入力してください。`;
      //   v.errMsg.push(msg);
      // }
  
      // 正規表現チェック
      const validItem = eval(regexType);
      if(!this.checkReg(v.$model, validItem)){
        const msg = `${name}は${validItem.type}で入力してください。`;
        v.errMsg.push(msg);
      }
      return v.errMsg.length == 0;
      // return msgList;
    },
    checkReg(val, validItem){
    // 正規表現チェック
      // if(validItem != null) validItem = eval(regexType);
      if (!this.emptyCheck(validItem) && val !== null&& val.length !== 0) {
        const regex = new RegExp(validItem.valid, 'g');
        if (!regex.test(val)) {
          
          return false;
        }
      }
      return true;
    },
    // undefined, nullの場合にtrueを返す
    emptyCheck(obj) {
      return (obj === undefined || obj == null);
    }
  };

